import { useEffect, useState } from 'react';

interface StickyCtaBarProps {
  onRequestAccess: () => void;
}

export default function StickyCtaBar({ onRequestAccess }: StickyCtaBarProps) {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const pastFirstViewport = window.scrollY > window.innerHeight;

      const footerEl = document.getElementById('site-footer');
      let hitFooter = false;
      if (footerEl) {
        const footerTop = footerEl.getBoundingClientRect().top;
        hitFooter = footerTop <= window.innerHeight;
      }

      setShouldShow(pastFirstViewport && !hitFooter);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[rgba(30,28,28,0.1)]"
      style={{
        opacity: shouldShow ? 1 : 0,
        transform: shouldShow ? 'translateY(0)' : 'translateY(100%)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        pointerEvents: shouldShow ? 'auto' : 'none',
      }}
    >
      {/* Mobile: full-width button */}
      <div className="md:hidden p-5">
        <button
          onClick={onRequestAccess}
          className="bg-primary rounded text-white p-4 font-body font-semibold text-[16px] w-full"
        >
          Book Free AI Visibility Review
        </button>
      </div>

      {/* Desktop: text + button row */}
      <div className="hidden md:flex items-center justify-between max-w-[800px] mx-auto py-4">
        <div className="flex flex-col font-body font-medium text-[18px] leading-[1.5]">
          <span className="text-[#1e1c1c]">Get Visible to AI</span>
          <span className="text-[rgba(30,28,28,0.7)]">Millions ask AI for recommendations</span>
        </div>
        <button
          onClick={onRequestAccess}
          className="bg-primary rounded text-white p-4 font-body font-semibold text-[16px]"
        >
          Book Free AI Visibility Review
        </button>
      </div>
    </div>
  );
}
